export const Notification ={
    AssessmentSubmittedNotification : 'AssessmentSubmittedNotification', 
    AssessmentRetakeNotification : 'AssessmentRetakeNotification', 
    FeedbackCompleteNotification: 'FeedbackCompleteNotification'
}